import BaseApiService from './baseApiService';
import { ExceedanceReportCreateCommand, ExceedanceReportDto, DownloadExceedanceReportQuery } from '../contracts';

class ExceedanceReportApiService extends BaseApiService {
    runReport = (year: number) => {
        return this.post<void, ExceedanceReportCreateCommand>('exceedance-report', { year });
    };

    loadCurrentState = () => {
        return this.get<ExceedanceReportDto>('exceedance-report');
    };

    downloadExceedanceReport = (id: number) => {
        return this.downloadFilePost<DownloadExceedanceReportQuery>(`exceedance-report/download`, {
            longOperationId: id
        }).then((resp) => resp.data);
    };
}

export default new ExceedanceReportApiService();
